import React from 'react';
export const myTripContextData = React.createContext({
  currentTrips: [],
  upcomingTrips: [],
  pastTrips: [],
  canceledTrips: [],
  deepLinkPrompt: '',
  hasMoreTrips: false,
  displayInRealtimeVoice: false,
  submitChatMessageInMarkerComponent: undefined
});
export const MyTripDataProvider = ({
  children,
  currentTrips,
  upcomingTrips,
  pastTrips,
  canceledTrips,
  deepLinkPrompt = '',
  hasMoreTrips = false,
  displayInRealtimeVoice = false,
  submitChatMessageInMarkerComponent = undefined
}) => {
  return React.createElement(myTripContextData.Provider, {
    value: {
      currentTrips,
      upcomingTrips,
      pastTrips,
      canceledTrips,
      deepLinkPrompt,
      hasMoreTrips,
      displayInRealtimeVoice,
      submitChatMessageInMarkerComponent
    }
  }, children);
};